import { isPhone, isWeb } from '@helpers';
import { LIST_WIDTH } from '@v2/pages/common/constants/base.constants';
import { fullWidth, width as fullWidthMobile } from '@components/frame';
import { TimelineSizes } from '@interfaces/timeline';

interface UseBatchTimelineSizesParams {
  width?: number;
  withoutList?: boolean;
  horizontalOffset?: number;
}

export const useBatchTimelineSizes = ({
  width = isWeb ? fullWidth : fullWidthMobile,
  withoutList = false,
  horizontalOffset = 0
}: UseBatchTimelineSizesParams = {}): TimelineSizes => {
  const padding = 36;

  const detailsWidth = (isPhone || withoutList ? width : width - LIST_WIDTH) - horizontalOffset;
  const blockWidth = detailsWidth - padding * 2;

  // Note: These popup sizes are different from the machine timeline
  const popupWidthProductivityStatus = 690;
  const popupHeightProductivityStatus = 304;

  const popupWidthProductivityStatusLabel = 50;
  const popupWidthProductivityStatusLabelSymbolSize = 9;
  const popupHeightProductivityStatusLabel = 42;

  const popupWidthAlarm = 30;
  const popupWidthAlarmSymbolSize = 9;
  const popupHeightAlarm = 42;

  const popupWidthNcFileName = 60;
  const popupWidthNcFileNameSymbolSize = 14;
  const popupHeightNcFileName = 42;

  return {
    padding,
    detailsWidth,
    blockWidth,
    popupWidthProductivityStatus,
    popupHeightProductivityStatus,
    popupWidthProductivityStatusLabel,
    popupWidthProductivityStatusLabelSymbolSize,
    popupHeightProductivityStatusLabel,
    popupWidthAlarm,
    popupWidthAlarmSymbolSize,
    popupHeightAlarm,
    popupWidthNcFileName,
    popupWidthNcFileNameSymbolSize,
    popupHeightNcFileName,
  };
};
